export type IdentityStatus = "missing" | "on_file" | "correction_required";

export interface IdentityState {
  enabled: boolean;
  status: IdentityStatus;
  version: number;
  reason?: string | null;
}

/** Require an explicit backend status; legacy approval is not evidence of a current ID. */
export function normalizeIdentityState(value: unknown): IdentityState {
  if (!value || typeof value !== "object")
    throw new Error("Identity status is unavailable. Please retry.");
  const data = value as Record<string, unknown>;
  if (data.enabled === false)
    return { enabled: false, status: "missing", version: 0 };
  const status = data.status;
  if (
    data.enabled !== true ||
    (status !== "missing" &&
      status !== "on_file" &&
      status !== "correction_required")
  )
    throw new Error("Identity status is unavailable. Please retry.");
  return {
    enabled: true,
    status,
    version: typeof data.version === "number" ? data.version : 0,
    reason: typeof data.reason === "string" ? data.reason : null,
  };
}

export function identityMessage(status: IdentityStatus) {
  if (status === "on_file")
    return {
      title: "ID on file",
      body: "Your ID is on file. Your clinician verifies your identity during prescribing. No new upload is needed unless your care team requests a correction.",
    };
  if (status === "correction_required")
    return {
      title: "Your ID needs an update",
      body: "Please upload the correction requested by your care team before treatment review. Your clinician verifies your identity during prescribing.",
    };
  return {
    title: "Upload your ID",
    body: "Upload the complete front of your government ID or passport photo page before treatment review. Your clinician verifies your identity during prescribing.",
  };
}
